import { render } from "./onlineSettingPart.vue?vue&type=template&id=cf52eda2&scoped=true"
import script from "./onlineSettingPart.vue?vue&type=script&lang=js"
export * from "./onlineSettingPart.vue?vue&type=script&lang=js"

import "./onlineSettingPart.vue?vue&type=style&index=0&id=cf52eda2&scoped=true&lang=less"

import exportComponent from "/root/drive/src/landing/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cf52eda2"]])

export default __exports__